import React from "react";

const TextImage = (props) => {
  //image left, text right, img src, text
  const { string1, string2, object3, string4, caption } = props;
  const finalImageClass = "image-container-" + string1;
  const finalTextClass = "text text-container-" + string2;

  return (
    <section className="content">
      <div className={finalImageClass}>
        <img src={object3} alt="" />
        <p className="caption">{caption}</p>
      </div>

      <div className={finalTextClass}>
        <p> {string4}</p>
        <br></br>
      </div>
    </section>
  );
};

export default TextImage;
